/// <reference types="./integrations.d.mts" />
import * as $bright from "../../../../bright/bright.mjs";
import * as $connector from "../../../../common/data/connector.mjs";
import * as $confluence from "../../../../common/data/connector/confluence.mjs";
import * as $notion from "../../../../common/data/connector/notion.mjs";
import * as $salesforce from "../../../../common/data/connector/salesforce.mjs";
import * as $unsafe from "../../../../common_common/gleam/unsafe.mjs";
import * as $brands from "../../../../ds/ds/brands.mjs";
import * as $button from "../../../../ds/ds/components/button.mjs";
import * as $input from "../../../../ds/ds/components/input.mjs";
import * as $l from "../../../../ds/ds/components/layout.mjs";
import * as $events from "../../../../ds/ds/events.mjs";
import * as $icons from "../../../../ds/ds/icons.mjs";
import * as $bool from "../../../../gleam_stdlib/gleam/bool.mjs";
import * as $decode from "../../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $int from "../../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../../gleam_stdlib/gleam/list.mjs";
import * as $pair from "../../../../gleam_stdlib/gleam/pair.mjs";
import * as $result from "../../../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../../../gleam_stdlib/gleam/string.mjs";
import * as $a from "../../../../lustre/lustre/attribute.mjs";
import * as $el from "../../../../lustre/lustre/element.mjs";
import * as $h from "../../../../lustre/lustre/element/html.mjs";
import * as $e from "../../../../lustre/lustre/event.mjs";
import * as $connectors from "../../../data/connectors.mjs";
import * as $model from "../../../data/model.mjs";
import * as $state from "../../../data/model/state.mjs";
import * as $msg from "../../../data/msg.mjs";
import * as $common from "../../../frontend/view/common.mjs";
import * as $s from "../../../frontend/view/styles/organization.mjs";
import { Ok, toList, isEqual } from "../../../gleam.mjs";

function view_connector(icon, title, description, children) {
  let child = children[0];
  let column = children[1];
  return $l.column(
    toList([$l.gap(12)]),
    toList([]),
    toList([
      $s.connectors_row(
        toList([]),
        toList([
          $s.connectors_description(
            toList([]),
            toList([
              $s.connectors_icon(icon()),
              $s.connectors_title(
                toList([]),
                toList([
                  $s.connectors_main_title(
                    toList([]),
                    toList([$el.text(title)]),
                  ),
                  $el.text(description),
                ]),
              ),
            ]),
          ),
          child,
        ]),
      ),
      column,
    ]),
  );
}

function disconnected_google_drive() {
  return $s.info_section(
    toList([]),
    toList([
      $s.info_title(
        "Google Drive is not connected to your Content Library yet!",
      ),
      $s.info_body(
        toList([
          "Steerlab connects to Google Drive to enrich your Content Library. ",
          "You can add one or multiple folders, according to your needs.",
        ]),
      ),
      $s.info_body(
        toList(["For further details, contact Steerlab's customer support."]),
      ),
    ]),
  );
}

function display_pages(pages, on_click_delete, delete_enabled) {
  return $bool.lazy_guard(
    $list.is_empty(pages),
    $el.none,
    () => {
      return $l.fragment(
        toList([
          $s.pages_list(
            toList([]),
            $list.map(
              pages,
              (page_url) => {
                return $s.page_name_with_deletion(
                  toList([]),
                  toList([
                    $h.text(page_url),
                    (() => {
                      if (delete_enabled) {
                        return $s.page_icon_delete(
                          toList([on_click_delete(page_url)]),
                          $icons.cross(),
                        );
                      } else {
                        return $el.none();
                      }
                    })(),
                  ]),
                );
              },
            ),
          ),
        ]),
      );
    },
  );
}

function on_remove_confluence_page(page_url) {
  let _pipe = $e.on_click(new $msg.UserRemovedConfluencePage(page_url));
  let _pipe$1 = $e.prevent_default(_pipe);
  return $e.stop_propagation(_pipe$1);
}

function view_confluence_pages(connectors, model) {
  let state = $bright.state(model);
  let pages = $state.get_confluence_pages(state);
  return $l.fragment(
    toList([
      $input.input(
        toList([
          $input.label("Add a new page"),
          $input.placeholder("Type the url here ..."),
          $input.on_input(
            (var0) => { return new $msg.UserUpdatedConfluencePageInput(var0); },
          ),
          $input.on_submit(new $msg.UserAddedConfluencePage()),
          $input.enter_submit(),
          $input.value(connectors.confluence_input_page_url),
        ]),
      ),
      display_pages(pages, on_remove_confluence_page, true),
    ]),
  );
}

function view_confluence_connection_config(connectors) {
  let disabled = $confluence.is_submit_disabled(connectors.confluence);
  let on_submit = $e.on_submit(
    (_) => {
      return new $msg.UserAskedConnectingTo(new $connector.Confluence());
    },
  );
  return $l.column(
    toList([$l.gap(12), $l.tag("form")]),
    toList([on_submit]),
    toList([
      $input.input(
        toList([
          $input.label("API Key"),
          $input.placeholder("xxxxxxx"),
          $input.on_input(
            (var0) => { return new $msg.UserUpdatedConfluenceApiKey(var0); },
          ),
          $input.value(connectors.confluence.api_key),
        ]),
      ),
      $input.input(
        toList([
          $input.label("Domain"),
          $input.placeholder("my_domain"),
          $input.on_input(
            (var0) => { return new $msg.UserUpdatedConfluenceDomain(var0); },
          ),
          $input.value(connectors.confluence.domain),
        ]),
      ),
      $input.input(
        toList([
          $input.label("User"),
          $input.placeholder("john@doe.com"),
          $input.on_input(
            (var0) => { return new $msg.UserUpdatedConfluenceUser(var0); },
          ),
          $input.value(connectors.confluence.user),
        ]),
      ),
      $l.row(
        toList([$l.justify("end")]),
        toList([]),
        toList([
          $button.primary(
            toList([$a.type_("submit"), $a.disabled(disabled)]),
            toList([$h.text("Submit")]),
          ),
        ]),
      ),
    ]),
  );
}

function on_remove_connected_website_page(page_url) {
  let _pipe = $e.on_click(new $msg.UserRemovedConnectedWebsitePage(page_url));
  let _pipe$1 = $e.prevent_default(_pipe);
  return $e.stop_propagation(_pipe$1);
}

function on_remove_sitemap_page(page_url) {
  let _pipe = $e.on_click(new $msg.UserRemovedSitemapPage(page_url));
  let _pipe$1 = $e.prevent_default(_pipe);
  return $e.stop_propagation(_pipe$1);
}

function on_remove_connected_gdrive_folder_url(page_url) {
  let _pipe = $e.on_click(new $msg.UserRemovedGoogleFolderUrl(page_url));
  let _pipe$1 = $e.prevent_default(_pipe);
  return $e.stop_propagation(_pipe$1);
}

function view_gdrive_configuration(model) {
  let state = $bright.state(model);
  let connected_folders = $state.get_google_folder_urls(state);
  let connected_folders_present = !$list.is_empty(connected_folders);
  let is_super_admin = $list.contains(state.permissions, "super-admin");
  return $l.column(
    toList([$l.gap(16)]),
    toList([]),
    toList([
      (() => {
        if (is_super_admin) {
          return $input.input(
            toList([
              $input.label("Connect new folder"),
              $input.placeholder("Copy paste the folder url here .."),
              $input.on_input(
                (var0) => {
                  return new $msg.UserUpdatedGoogleFolderUrlInput(var0);
                },
              ),
              $input.on_submit(new $msg.UserAddedGoogleFolderUrl()),
              $input.enter_submit(),
              $input.value(state.connectors.google_input_folder_url),
            ]),
          );
        } else {
          return $el.none();
        }
      })(),
      (() => {
        if (connected_folders_present) {
          let count = $int.to_string($list.length(connected_folders));
          return $l.column(
            toList([$l.gap(6)]),
            toList([]),
            toList([
              $s.connector_divider_sub_title(
                toList([]),
                toList([$h.text(("Connected folders ( " + count) + " )")]),
              ),
              $s.website_pages_wrapper(
                toList([]),
                toList([
                  display_pages(
                    connected_folders,
                    on_remove_connected_gdrive_folder_url,
                    false,
                  ),
                ]),
              ),
            ]),
          );
        } else {
          return disconnected_google_drive();
        }
      })(),
    ]),
  );
}

function sitemap_upload_action() {
  return $h.label(
    toList([]),
    toList([
      $s.sitemap_file_input(
        toList([]),
        toList([$icons.small($icons.add()), $h.text("Upload sitemap")]),
      ),
      $h.input(
        toList([
          $a.type_("file"),
          $a.style("display", "none"),
          $events.on_files_change(
            (files) => {
              let $ = $list.first(files);
              if ($ instanceof Ok) {
                let file = $[0];
                return $decode.success(new $msg.UserUploadedSiteMap(file));
              } else {
                return $decode.failure($unsafe.coerce(""), "");
              }
            },
          ),
        ]),
      ),
    ]),
  );
}

function view_sitemap_buttons(model) {
  let state = $bright.state(model);
  let pages = state.connectors.website_sitemap_pages;
  let sync_links = $e.on_click(new $msg.UserRequetedSitemapSync());
  let sitemap_pages_present = !$list.is_empty(pages);
  return $l.row(
    toList([$l.justify("space-between"), $l.align("center")]),
    toList([]),
    toList([
      $s.connector_divider_sub_title(toList([]), toList([$h.text("Or")])),
      $l.row(
        toList([$l.gap(8)]),
        toList([]),
        toList([
          sitemap_upload_action(),
          (() => {
            if (sitemap_pages_present) {
              return $button.secondary(
                toList([sync_links]),
                toList([$h.text("Connect sitemap pages")]),
              );
            } else {
              return $el.none();
            }
          })(),
        ]),
      ),
    ]),
  );
}

function view_website_configuration(model) {
  let state = $bright.state(model);
  let is_super_admin = $list.contains(state.permissions, "super-admin");
  let connected_pages = $state.get_website_pages(state);
  let connected_pages_present = !$list.is_empty(connected_pages);
  let sitemap_pages = state.connectors.website_sitemap_pages;
  let sitemap_pages_present = !$list.is_empty(sitemap_pages);
  return $l.column(
    toList([$l.gap(16)]),
    toList([]),
    toList([
      $input.input(
        toList([
          $input.label("Add a new web page"),
          $input.placeholder("Type the url here ..."),
          $input.on_input(
            (var0) => { return new $msg.UserUpdatedWebsitePageInput(var0); },
          ),
          $input.on_submit(new $msg.UserAddedWebsitePage()),
          $input.enter_submit(),
          $input.value(state.connectors.website_input_page_url),
        ]),
      ),
      (() => {
        if (is_super_admin) {
          return view_sitemap_buttons(model);
        } else {
          return $el.none();
        }
      })(),
      (() => {
        let $ = is_super_admin && sitemap_pages_present;
        if ($) {
          return $l.column(
            toList([$l.gap(6)]),
            toList([]),
            toList([
              $s.connector_divider_sub_title(
                toList([]),
                toList([
                  $h.text(
                    ("Sitemap pages ( " + (() => {
                      let _pipe = $list.length(sitemap_pages);
                      return $int.to_string(_pipe);
                    })()) + " )",
                  ),
                ]),
              ),
              $s.website_pages_wrapper(
                toList([]),
                toList([
                  display_pages(sitemap_pages, on_remove_sitemap_page, true),
                ]),
              ),
              $common.separator(),
            ]),
          );
        } else {
          return $el.none();
        }
      })(),
      (() => {
        if (connected_pages_present) {
          return $l.column(
            toList([$l.gap(6)]),
            toList([]),
            toList([
              $s.connector_divider_sub_title(
                toList([]),
                toList([
                  $h.text(
                    ("Connected pages ( " + (() => {
                      let _pipe = $list.length(connected_pages);
                      return $int.to_string(_pipe);
                    })()) + " )",
                  ),
                ]),
              ),
              $s.website_pages_wrapper(
                toList([]),
                toList([
                  display_pages(
                    connected_pages,
                    on_remove_connected_website_page,
                    true,
                  ),
                ]),
              ),
            ]),
          );
        } else {
          return $el.none();
        }
      })(),
    ]),
  );
}

function view_refresh_data_button(connected, connector) {
  return $bool.guard(
    !connected,
    $el.none(),
    () => {
      let refresh_handler = $e.on_click(
        new $msg.UserFetchedConnectorData(connector),
      );
      return $button.secondary(
        toList([refresh_handler]),
        toList([$h.text("Refresh data")]),
      );
    },
  );
}

function view_gdrive_inputs_actions(connected, opened) {
  let toggle_handler = $e.on_click(new $msg.UserToggledGoogleDrivePanel());
  return $s.connector_row_actions(
    toList([]),
    toList([
      view_refresh_data_button(connected, new $connector.GoogleDrive()),
      $button.secondary(
        toList([toggle_handler]),
        toList([
          $el.text(
            (() => {
              if (opened) {
                return "Close";
              } else {
                return "Open";
              }
            })(),
          ),
        ]),
      ),
    ]),
  );
}

function view_gdrive_connection(model) {
  let state = $bright.state(model);
  let _block;
  let _pipe = $state.get_google_folder_urls(state);
  let _pipe$1 = $list.is_empty(_pipe);
  _block = $bool.negate(_pipe$1);
  let connected = _block;
  let opened = state.connectors.google_drive_opened;
  let _pipe$2 = view_gdrive_inputs_actions(connected, opened);
  return $pair.new$(
    _pipe$2,
    (() => {
      if (opened) {
        return view_gdrive_configuration(model);
      } else {
        return $el.none();
      }
    })(),
  );
}

function view_confluence_inputs_actions(opened, connected) {
  let toggle_handler = $e.on_click(new $msg.UserToggledConfluencePanel());
  return $s.connector_row_actions(
    toList([]),
    toList([
      view_refresh_data_button(connected, new $connector.Confluence()),
      $button.secondary(
        toList([$a.disabled(connected), toggle_handler]),
        toList([
          $h.text(
            (() => {
              if (connected) {
                return "Connected";
              } else if (opened) {
                return "Close";
              } else {
                return "Connect";
              }
            })(),
          ),
        ]),
      ),
    ]),
  );
}

function view_confluence_connection(connectors, model) {
  let opened = connectors.confluence_opened;
  let _block;
  let _pipe = connectors.fetched;
  let _pipe$1 = $list.key_find(_pipe, new $connector.Confluence());
  _block = $result.unwrap(_pipe$1, false);
  let connected = _block;
  let _pipe$2 = view_confluence_inputs_actions(opened, connected);
  return $pair.new$(
    _pipe$2,
    (() => {
      if (connected) {
        return view_confluence_pages(connectors, model);
      } else if (!opened) {
        return $el.none();
      } else {
        return view_confluence_connection_config(connectors);
      }
    })(),
  );
}

function view_website_inputs_actions(opened, connected) {
  let toggle_handler = $e.on_click(new $msg.UserToggledWebsitePanel());
  return $s.connector_row_actions(
    toList([]),
    toList([
      view_refresh_data_button(connected, new $connector.Website()),
      $button.secondary(
        toList([toggle_handler]),
        toList([
          $h.text(
            (() => {
              if (opened) {
                return "Close";
              } else {
                return "Open";
              }
            })(),
          ),
        ]),
      ),
    ]),
  );
}

function view_website_connection(model) {
  let state = $bright.state(model);
  let opened = state.connectors.website_opened;
  let _block;
  let _pipe = $state.get_website_pages(state);
  let _pipe$1 = $list.is_empty(_pipe);
  _block = $bool.negate(_pipe$1);
  let connected = _block;
  let _pipe$2 = view_website_inputs_actions(opened, connected);
  return $pair.new$(
    _pipe$2,
    (() => {
      if (opened) {
        return view_website_configuration(model);
      } else {
        return $el.none();
      }
    })(),
  );
}

function view_notion_input_actions(connector, opened, connected) {
  let toggle_handler = $e.on_click(new $msg.UserToggledNotionPanel());
  return $s.connector_row_actions(
    toList([]),
    toList([
      view_refresh_data_button(connected, connector),
      $button.secondary(
        toList([$a.disabled(connected), toggle_handler]),
        toList([
          $h.text(
            (() => {
              if (connected) {
                return "Connected";
              } else if (opened) {
                return "Close";
              } else {
                return "Open";
              }
            })(),
          ),
        ]),
      ),
    ]),
  );
}

function view_notion_connection(connectors) {
  let connector = new $connector.Notion();
  let opened = connectors.notion_opened;
  let _block;
  let _pipe = connectors.fetched;
  let _pipe$1 = $list.key_find(_pipe, connector);
  _block = $result.unwrap(_pipe$1, false);
  let connected = _block;
  let _pipe$2 = view_notion_input_actions(connector, opened, connected);
  return $pair.new$(
    _pipe$2,
    $bool.guard(
      connected,
      $el.none(),
      () => {
        return $bool.guard(
          !opened,
          $el.none(),
          () => {
            let disabled = $notion.is_submit_disabled(connectors.notion);
            let on_submit = $e.on_submit(
              (_) => {
                return new $msg.UserAskedConnectingTo(new $connector.Notion());
              },
            );
            return $l.column(
              toList([$l.gap(12), $l.tag("form")]),
              toList([on_submit]),
              toList([
                $input.input(
                  toList([
                    $input.label("API Key"),
                    $input.placeholder("xxxxxxx"),
                    $input.on_input(
                      (var0) => {
                        return new $msg.UserUpdatedNotionApiKey(var0);
                      },
                    ),
                    $input.value(connectors.notion.api_key),
                  ]),
                ),
                $input.input(
                  toList([
                    $input.label("Page ids"),
                    $input.placeholder(
                      "https://notion.so/workspace/page_1;https://notion.so/workspace/page_2",
                    ),
                    $input.on_input(
                      (var0) => {
                        return new $msg.UserUpdatedNotionPageId(var0);
                      },
                    ),
                    $input.value($string.join(connectors.notion.page_ids, ";")),
                  ]),
                ),
                $l.row(
                  toList([$l.justify("end")]),
                  toList([]),
                  toList([
                    $button.primary(
                      toList([$a.type_("submit"), $a.disabled(disabled)]),
                      toList([$h.text("Submit")]),
                    ),
                  ]),
                ),
              ]),
            );
          },
        );
      },
    ),
  );
}

function disconnected_salesforce() {
  return $s.info_section(
    toList([]),
    toList([
      $s.info_title("Salesforce is not connected to your Steerlab account yet!"),
      $s.info_body(
        toList([
          "Steerlab connects to Salesforce to link things like opportunity, case ids to Steerlab Projects. ",
          "For further details, contact Steerlab's customer support.",
        ]),
      ),
    ]),
  );
}

function view_salesforce_connection_config(connected, model) {
  let state = $bright.state(model);
  let disabled = $salesforce.is_submit_disabled(state.connectors.salesforce);
  let on_submit = $e.on_submit(
    (_) => {
      return new $msg.UserAskedConnectingTo(new $connector.Salesforce());
    },
  );
  let is_super_admin = $list.contains(state.permissions, "super-admin");
  return $l.column(
    toList([$l.gap(16)]),
    toList([]),
    toList([
      (() => {
        if (!connected) {
          return disconnected_salesforce();
        } else {
          return $el.none();
        }
      })(),
      (() => {
        let $ = is_super_admin && !connected;
        if ($) {
          return $l.column(
            toList([$l.gap(12), $l.tag("form")]),
            toList([on_submit]),
            toList([
              $input.input(
                toList([
                  $input.label("Domain"),
                  $input.placeholder("my_domain"),
                  $input.on_input(
                    (var0) => {
                      return new $msg.UserUpdatedSalesforceDomain(var0);
                    },
                  ),
                  $input.value(state.connectors.salesforce.domain),
                ]),
              ),
              $input.input(
                toList([
                  $input.label("Client Id"),
                  $input.placeholder("xxxxxxx"),
                  $input.on_input(
                    (var0) => {
                      return new $msg.UserUpdatedSalesforceClientId(var0);
                    },
                  ),
                  $input.value(state.connectors.salesforce.client_id),
                ]),
              ),
              $input.input(
                toList([
                  $input.label("Client Secret"),
                  $input.placeholder("xxxxxxx"),
                  $input.on_input(
                    (var0) => {
                      return new $msg.UserUpdatedSalesforceClientSecret(var0);
                    },
                  ),
                  $input.value(state.connectors.salesforce.client_secret),
                ]),
              ),
              $l.row(
                toList([$l.justify("end")]),
                toList([]),
                toList([
                  $button.primary(
                    toList([$a.type_("submit"), $a.disabled(disabled)]),
                    toList([$h.text("Submit")]),
                  ),
                ]),
              ),
            ]),
          );
        } else {
          return $el.none();
        }
      })(),
    ]),
  );
}

function view_salesforce_inputs_actions(opened, connected) {
  let toggle_handler = $e.on_click(new $msg.UserToggledSalesforcePanel());
  return $s.connector_row_actions(
    toList([]),
    toList([
      $button.secondary(
        toList([$a.disabled(connected), toggle_handler]),
        toList([
          $h.text(
            (() => {
              if (connected) {
                return "Connected";
              } else if (opened) {
                return "Close";
              } else {
                return "Connect";
              }
            })(),
          ),
        ]),
      ),
    ]),
  );
}

function view_salesforce_connection(connectors, model) {
  let opened = connectors.salesforce_opened;
  let _block;
  let _pipe = connectors.fetched;
  let _pipe$1 = $list.key_find(_pipe, new $connector.Salesforce());
  _block = $result.unwrap(_pipe$1, false);
  let connected = _block;
  let _pipe$2 = view_salesforce_inputs_actions(opened, connected);
  return $pair.new$(
    _pipe$2,
    (() => {
      if (opened) {
        return view_salesforce_connection_config(connected, model);
      } else {
        return $el.none();
      }
    })(),
  );
}

export function view(model) {
  let state = $bright.state(model);
  return $l.fragment(
    toList([
      $l.fragment(
        toList([
          $common.underlined_title(
            toList([]),
            toList([$el.text("Apps"), $common.separator()]),
          ),
          $s.connectors_block(
            toList([]),
            toList([
              $s.connectors_card(
                toList([]),
                toList([
                  $s.connectors_card_icon($brands.slack()),
                  $s.connector_title(toList([]), toList([$el.text("Slack")])),
                  $s.connector_content(
                    toList([]),
                    toList([
                      $el.text(
                        "Connect your Slack, and ask questions to Steerlab",
                      ),
                      $el.text(" directly in your channel!"),
                    ]),
                  ),
                  (() => {
                    let fetched = new Ok(false);
                    return $button.secondary(
                      toList([
                        $e.on_click(
                          new $msg.UserAskedConnectingTo(new $connector.Slack()),
                        ),
                        $a.disabled(isEqual(fetched, new Ok(true))),
                      ]),
                      toList([
                        $el.text(
                          (() => {
                            let $ = fetched[0];
                            if ($) {
                              return "Installed";
                            } else {
                              return "Install";
                            }
                          })(),
                        ),
                      ]),
                    );
                  })(),
                ]),
              ),
              $s.connectors_spacer(toList([]), toList([])),
              $s.connectors_spacer(toList([]), toList([])),
            ]),
          ),
        ]),
      ),
      $common.underlined_title(
        toList([]),
        toList([$el.text("Data connections"), $common.separator()]),
      ),
      view_connector(
        $icons.globe,
        "Website",
        "Connect your website",
        view_website_connection(model),
      ),
      view_connector(
        $brands.drive,
        "Google Drive",
        "Connect to your Google Drive",
        view_gdrive_connection(model),
      ),
      view_connector(
        $brands.confluence,
        "Confluence",
        "Connect to your Confluence",
        view_confluence_connection(state.connectors, model),
      ),
      view_connector(
        $brands.notion,
        "Notion",
        "Connect to your notion",
        view_notion_connection(state.connectors),
      ),
      $common.underlined_title(
        toList([]),
        toList([$el.text("CRM connections"), $common.separator()]),
      ),
      view_connector(
        $brands.salesforce,
        "Salesforce",
        "Connect your Salesforce",
        view_salesforce_connection(state.connectors, model),
      ),
    ]),
  );
}
